import get from 'lodash/get';

import * as actions from 'actions/temporaryAbsenceList';
import { getParameterByName } from '@xmatters/common/utils/string';

import { scrollAndLoadHelper } from '../reducerUtils';

const defaultState = {
  isDeletionPromptVisible: false,

  listFirstPage: {},
  list: {
    data: [],
    count: 0,
    total: 0,
  },

  isInitialListLoading: false,

  isAbsenceListVisible: false,
  isListLoading: false,

  didLoadingListFail: false,
  loadingListErrorMsg: '',

  didDeletionFail: false,
  deletionErrorMsg: '',
};

export default function temporaryAbsenceList(state = defaultState, action) {
  const { payload } = action;
  switch (action.type) {
    case actions.DELETE_TEMP_ABSENCE_SHOW:
      return payload.open
        ? {
            ...state,
            isDeletionPromptVisible: true,
          }
        : {
            ...state,
            isDeletionPromptVisible: false,
          };
    case actions.TEMP_ABSENCE_LIST_SHOW:
      return payload.open
        ? {
            ...state,
            isAbsenceListVisible: true,
          }
        : {
            ...state,
            isAbsenceListVisible: false,
          };
    case actions.LOAD_INITIAL_TEMP_ABSENCE_LIST_START:
      return {
        ...state,
        isInitialListLoading: true,
      };
    case actions.LOAD_INITIAL_TEMP_ABSENCE_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...payload,
        },
        isInitialListLoading: false,
        didLoadingListFail: false,
      };
    case actions.LOAD_INITIAL_TEMP_ABSENCE_LIST_FAIL:
      return {
        ...state,
        list: {},
        didLoadingListFail: true,
        loadingListErrorMsg: get(action, 'payload.json.message', null),
        isInitialListLoading: false,
      };
    case actions.LOAD_TEMP_ABSENCE_LIST_START:
      return {
        ...state,
        isListLoading: true,
      };
    case actions.LOAD_TEMP_ABSENCE_LIST_SUCCESS: {
      const offset = parseInt(
        getParameterByName('offset', payload.links.self),
        10,
      );
      const currentAbsenceList = state.list.data;
      const newAbsenceList = scrollAndLoadHelper(
        offset,
        currentAbsenceList,
        payload,
      );
      return {
        ...state,
        list: {
          data: newAbsenceList,
          count: payload.count,
          total: payload.total,
        },
        isListLoading: false,
        didLoadingListFail: false,
      };
    }
    case actions.LOAD_TEMP_ABSENCE_LIST_FAIL:
      return {
        ...state,
        list: {},
        didLoadingListFail: true,
        loadingListErrorMsg: get(action, 'payload.json.message', null),
        isListLoading: false,
      };
    case actions.DELETE_TEMP_ABSENCE_FAIL:
      return {
        ...state,
        didDeletionFail: true,
        deletionErrorMsg: get(action, 'payload.json.message', null),
      };
    case actions.DELETE_TEMP_ABSENCE_SUCCESS:
      return {
        ...state,
        didDeletionFail: false,
        deletionErrorMsg: null,
      };
    default:
      return state;
  }
}
